import * as MdIcons from "react-icons/md";

export const ALL_USER_ICONS = Object.keys(MdIcons).filter((name) =>
  name.startsWith("Md"),
);
